export default __webpack_public_path__ + "static/media/plus-blue.5667f581.svg";